import { API } from "../../src/api"

export const fileUpload = async (formData) => {
  return API.post("/utils/file-upload", formData)
}
